import { cn } from '@/lib/utils';

/** Public filenames (`apps/frontend/public/`). Encode spaces only — Vite static serving breaks when `@` is `%40`. */
function publicAssetPath(filename: string): string {
  return `/${filename.replace(/ /g, '%20')}`;
}

const BRAND_LOGO_COMPACT_SRC = publicAssetPath('logo icon ver2@3x.png');
const BRAND_LOGO_FULL_SRC = publicAssetPath('Logo ver2@3x.png');

interface BrandLogoProps {
  className?: string;
  compact?: boolean;
}

export function BrandLogo({ className, compact = false }: BrandLogoProps): JSX.Element {
  if (compact) {
    return (
      <div
        className={cn('flex shrink-0 items-center justify-center pl-2', className)}
        aria-label="CodeMerlin"
        title="CodeMerlin"
      >
        <img src={BRAND_LOGO_COMPACT_SRC} alt="CodeMerlin" className="h-8 w-8 object-contain" />
      </div>
    );
  }

  return (
    <img
      src={BRAND_LOGO_FULL_SRC}
      alt="CodeMerlin"
      className={cn('h-full w-auto object-contain', className)}
    />
  );
}
